import classNames from 'classnames';
import { IconSize } from 'src/interfaces/Icon';
import usePlayback from 'src/hooks/usePlayback';
import useWatchTime from 'src/hooks/useWatchTime';
import usePlayerData from 'src/hooks/usePlayerData';
import PlayControl from '../../components/PlayControl';
import ForwardControl from '../../components/ForwardControl';
import RewindControl from '../../components/RewindControl';
import styles from './styles.module.scss';

export interface IMobilePlaybackControlProps {
  size: IconSize.medium | IconSize.large;
}

const MobilePlaybackControls = ({ size }: IMobilePlaybackControlProps) => {
  const { paused, togglePlay } = usePlayback();
  const { forwardSeconds, backwardSeconds } = useWatchTime();
  const {
    playerData: { live: isLive },
  } = usePlayerData();

  return (
    <div role='group' className={classNames(styles.container, styles[size])}>
      {!isLive && <RewindControl className={styles.rewindControl} onClick={backwardSeconds} iconSize={size} />}
      <PlayControl className={styles.playControl} paused={paused} onClick={togglePlay} />
      {!isLive && <ForwardControl className={styles.forwardControl} onClick={forwardSeconds} iconSize={size} />}
    </div>
  );
};

export default MobilePlaybackControls;
